export const TERMINAL_MISSION_STATUSES = new Set([
    "idle",
    "completed",
    "failed",
    "cancelled",
    "canceled",
    "succeeded",
]);

export interface ExecutorStateLike {
    status?: string;
    mission_id?: string;
}

export interface ActiveMissionInput {
    executorState: ExecutorStateLike | null;
    isExecuting: boolean;
    currentMissionId: string | null;
}

export const resolveActiveMissionId = ({
    executorState,
    isExecuting,
    currentMissionId,
}: ActiveMissionInput): string | null => {
    const normalizedExecutorStatus = String(executorState?.status || "").trim().toLowerCase();
    const normalizedExecutorMissionId = String(executorState?.mission_id || "").trim();
    const isExecutorMissionActive =
        Boolean(normalizedExecutorMissionId) &&
        !TERMINAL_MISSION_STATUSES.has(normalizedExecutorStatus);
    const normalizedRunningMissionId = String(currentMissionId || "").trim();

    return (
        (isExecutorMissionActive && normalizedExecutorMissionId) ||
        (isExecuting && normalizedRunningMissionId) ||
        null
    );
};

/** Prefer the running mission; otherwise the mission open in create/edit. */
export const resolveMapWaypointMissionId = ({
    activeMissionId,
    editingMissionId,
}: {
    activeMissionId: string | null;
    editingMissionId: string | null;
}): string | null => {
    const active = String(activeMissionId || "").trim();
    if (active) return active;
    const editing = String(editingMissionId || "").trim();
    return editing || null;
};
